const isVideoLink = (url) => {
  const regex = /\.(mp4|m4v|mov|avi|wmv|flv|mkv|webm)$/i;
  const fileName = url.slice(url.lastIndexOf("/") + 1);
  return regex.test(url) || fileName.toUpperCase().startsWith("VID");
};
export default isVideoLink;
